import config from '../config'
import { requests } from '.'

export const AdvancedSettingsService = {
  getConversationChannels: async (locationId: string, type: "SMS" | "Email") => {
    try {
      const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
        `/locations/${locationId}/conversationChannels/${type}`
      )

      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  saveConversationChannels: async (locationId: string, payload: any) => {
    try {
      const { data } = await requests(config.MARKETPLACE_REST_API_URL).put(
        `/locations/${locationId}/conversationChannels`, payload
      )

      return Promise.resolve(data)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
